export default "__VITE_ASSET__a0390b3c__"